<template>
    <div class="upload-button-wrap">
        <oss-upload
            ref="uploader"
            v-model="innerValue"
            hidden
            :accept="accept"
            :disabled="disabled"
            :folder="folder"
            :max="max"
            :max-size="maxSize"
            :multiple="multiple"
            :show-preview="false"
            @change="handleChange"
            @error="handleError"
            @exceed="handleExceed"
            @remove="handleRemove"
            @success="handleSuccess"
            @upload-end="handleUploadEnd"
            @upload-progress="handleUploadProgress"
            @upload-start="handleUploadStart" />
        <el-button
            v-if="!hidden"
            :disabled="buttonDisabled"
            :size="buttonSize"
            :type="buttonType"
            @click="openPicker">
            {{ buttonText }}
        </el-button>
        <div v-if="!hidden && tip" class="upload-button-tip">{{ tip }}</div>
    </div>
</template>

<script>
export default {
    name: 'UploadButton',
    props: {
        value: {
            type: Array,
            default: () => []
        },
        accept: {
            type: String,
            default: ''
        },
        buttonSize: {
            type: String,
            default: 'small'
        },
        buttonType: {
            type: String,
            default: 'primary'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        folder: {
            type: String,
            default: ''
        },
        hidden: {
            type: Boolean,
            default: false
        },
        max: {
            type: Number,
            default: 1
        },
        maxSize: {
            type: Number,
            default: 10
        },
        multiple: {
            type: Boolean,
            default: false
        },
        tip: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: '上传文件'
        }
    },
    data() {
        return {
            innerValue: this.normalizeFileList(this.value),
            uploading: false,
            progress: 0
        }
    },
    computed: {
        buttonDisabled() {
            if (this.disabled) {
                return true
            }
            return this.innerValue.length >= this.max
        },
        buttonText() {
            if (!this.uploading) {
                return this.title
            }
            return `${this.title} ${this.progress}%`
        }
    },
    watch: {
        value(val) {
            this.innerValue = this.normalizeFileList(val)
        }
    },
    methods: {
        normalizeFileList(list) {
            if (!Array.isArray(list)) {
                return []
            }
            return list.map(item => {
                if (typeof item === 'string') {
                    return {
                        url: item,
                        name: item.split('/').pop()
                    }
                }
                return { ...item }
            })
        },
        openPicker() {
            if (this.buttonDisabled) {
                return
            }
            if (this.$refs.uploader) {
                this.$refs.uploader.openPicker()
            }
        },
        clearFiles() {
            if (this.$refs.uploader) {
                this.$refs.uploader.clearFiles()
            }
        },
        emitValue(fileList) {
            this.innerValue = this.normalizeFileList(fileList)
            this.$emit('input', this.innerValue)
            this.$emit('change', this.innerValue)
        },
        handleChange(fileList) {
            this.emitValue(fileList)
        },
        handleRemove({ fileList }) {
            this.emitValue(fileList)
            this.$emit('remove', { fileList })
        },
        handleSuccess(payload) {
            this.emitValue(payload.fileList)
            this.$emit('success', payload)
        },
        handleError(payload) {
            this.uploading = false
            this.progress = 0
            this.$emit('error', payload)
        },
        handleExceed() {
            this.$emit('exceed')
        },
        handleUploadStart(payload) {
            this.uploading = true
            this.progress = 0
            this.$emit('upload-start', payload)
        },
        handleUploadProgress(payload) {
            this.progress = payload.percent || 0
            this.$emit('upload-progress', payload)
        },
        handleUploadEnd(payload) {
            this.uploading = false
            this.progress = 0
            this.$emit('upload-end', payload)
        }
    }
}
</script>

<style scoped>
.upload-button-tip {
    margin-top: 8px;
    font-size: 12px;
    line-height: 20px;
    color: #909399;
}
</style>



// WEBPACK FOOTER //
// src/components/UploadButton.vue